import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  ChartBar,
  ChatsCircle,
  Clock,
  GridFour,
  Kanban,
  LinkSimple,
  MegaphoneSimple,
  Moon,
  PaperPlaneTilt,
  Sun,
} from '@phosphor-icons/react';
import { cn } from '@/lib/utils';

const NAV = [
  { to: '/', label: 'Dashboard', icon: GridFour, end: true, id: 'dashboard' },
  { to: '/instances', label: 'Instâncias', icon: ChartBar, id: 'instances' },
  { to: '/campaigns', label: 'Campanhas', icon: MegaphoneSimple, id: 'campaigns' },
  { to: '/broadcast', label: 'Broadcast', icon: PaperPlaneTilt, id: 'broadcast' },
  { to: '/inbox', label: 'Inbox', icon: ChatsCircle, id: 'inbox' },
  { to: '/crm', label: 'CRM', icon: Kanban, id: 'crm' },
  { to: '/links', label: 'Links', icon: LinkSimple, id: 'links' },
  { to: '/logs', label: 'Histórico', icon: Clock, id: 'logs' },
];

export default function Sidebar({ theme, onToggleTheme, className = '', onNavigate }) {
  const loc = useLocation();

  return (
    <aside
      className={cn('s1-sidebar w-[272px] shrink-0 flex flex-col border-r px-[22px] py-[30px]', className)}
      style={{ background: 'var(--s1-sidebar)', borderColor: 'var(--s1-line)' }}
      data-testid="sidebar"
    >
      <div className="px-1">
        <div className="brand-script text-[30px] leading-none">Simplific</div>
        <div className="mt-3 flex items-center gap-2">
          <span className="text-[12px] font-semibold uppercase tracking-[0.42em]" style={{ color: 'var(--s1-gold-text)' }}>ONE</span>
          <span className="h-[13px] w-px" style={{ background: 'var(--s1-divider)' }} />
          <span className="text-[12px] font-semibold" style={{ color: 'var(--s1-accent-text)' }}>Groups</span>
        </div>
      </div>

      <nav className="mt-10 flex flex-col gap-1">
        {NAV.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={onNavigate}
              data-testid={`nav-${item.id}`}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-[var(--s1-radius-nav)] border px-4 py-3 text-sm transition-all duration-200',
                  isActive ? 'font-semibold' : 'font-medium'
                )
              }
              style={({ isActive }) => ({
                background: isActive
                  ? 'linear-gradient(90deg, var(--s1-accent-glass), color-mix(in srgb, var(--s1-accent-glass) 38%, transparent))'
                  : 'transparent',
                borderColor: isActive ? 'color-mix(in srgb, var(--s1-accent) 58%, var(--s1-card-border))' : 'transparent',
                boxShadow: isActive ? 'inset 3px 0 0 var(--s1-accent), var(--s1-glow)' : 'none',
                color: isActive ? 'var(--s1-accent-text)' : 'var(--s1-text-2)',
              })}
            >
              <Icon size={18} weight={loc.pathname === item.to ? 'duotone' : 'regular'} />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      <div className="mt-auto border-t px-1 pt-4" style={{ borderColor: 'var(--s1-line-soft)' }}>
        <button
          type="button"
          onClick={onToggleTheme}
          className="mb-4 flex w-full items-center justify-between rounded-full border px-4 py-2"
          style={{
            background: 'var(--s1-card)',
            borderColor: 'var(--s1-card-border)',
            color: 'var(--s1-text-2)',
          }}
        >
          <span className="text-[10px] font-semibold uppercase tracking-[0.14em]">
            {theme === 'dark' ? 'Modo escuro' : 'Modo claro'}
          </span>
          <span className="grid h-7 w-7 place-items-center rounded-full" style={{ background: 'var(--s1-accent-soft)', color: 'var(--s1-accent-text)' }}>
            {theme === 'dark' ? <Moon size={15} /> : <Sun size={15} />}
          </span>
        </button>
        <p className="text-[10px] font-semibold uppercase tracking-[0.14em]" style={{ color: 'var(--s1-faint)' }}>
          Simplific ONE · v0.1
        </p>
        <p className="mt-1 text-[11px] font-medium" style={{ color: 'var(--s1-faint)' }}>
          Evolution Engine
        </p>
      </div>
    </aside>
  );
}
